<div *transloco="let t">
	<div class="px-12 flex flex-row">
		<div class="pt-6 pb-3 title">
			{{ t('settings.devSettings.frontendTools.iconTester') }}
		</div>
	</div>
	<div class="px-12 flex flex-row">
		<button (click)="openIconTester()" class="{{ isMobile() ? 'w/full' : '' }} p-2 m-2" color="primary" mat-raised-button type="button">
			{{ t('settings.devSettings.frontendTools.openIconTester') }}
		</button>
	</div>
	<div class="px-12 flex flex-row">
		<div class="pt-6 pb-3 title">Snackbars</div>
	</div>
	<div class=" px-12 flex {{ isMobile() ? 'flex-col' : 'flex-row w-2/3' }}">
		<div class="{{ isMobile() ? 'w-full' : 'w-1/5' }}">
			<button (click)="showSuccessSnackbar()" class="w-full p-2 m-4 success-snackbar" color="green" mat-raised-button type="button">Success</button>
		</div>
		<div class="{{ isMobile() ? 'w-full' : 'w-1/5' }}">
			<button (click)="showErrorSnackbar()" class="w-full p-2 m-4 error-snackbar" color="red" mat-raised-button type="button">Error</button>
		</div>
		<div class="{{ isMobile() ? 'w-full' : 'w-1/5' }}">
			<button (click)="showWarnSnackbar()" class="w-full p-2 m-4 warn-snackbar" color="yellow" mat-raised-button type="button">Warn</button>
		</div>
	</div>
</div>
